import React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography, Button } from "@mui/material";
import small_truck from "../../../assets/images/small_truck.png";
import Facebook from "../../../assets/images/facebook.png";
import Twitter from "../../../assets/images/twitter.png";
import Whatsapp from "../../../assets/images/whatsapp.png";
import Messanger from "../../../assets/images/messanger.png";
import Sms from "../../../assets/images/sms.png";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function BottomShareModal({ open, toggleDrawer }) {
  const smallHeight = useMediaQuery("(max-height:550px)");
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => toggleDrawer(false)}
      sx={{}}
      PaperProps={{
        sx: {
          padding: "0",
          minHeight: smallHeight ? "408px" : "542px",
          borderRadius: "16px 16px 0px 0px",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <CloseIcon
        onClick={()=>toggleDrawer(false)}
        sx={{
          marginTop: "26px",
          marginLeft: "20px",
          "&:hover": {
            cursor: "pointer",
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginTop: "26px",
          marginBottom: "24px",
          marginLeft: "24px",
          rowGap: "24px",
        }}
      >
        {!smallHeight && (
          <>
            <Typography
              variant="h3"
              fontFamily="Inter"
              fontSize="22px"
              fontWeight="600"
              lineHeight="26px"
              color="black"
            >
              Share this machinery
            </Typography>
            <Box
              sx={{
                display: "flex",
                columnGap: "16px",
                alignItems: "center",
              }}
            >
              <img
                src={small_truck}
                alt="small truck"
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
              />
              <Typography
                variant="body2"
                fontFamily="Inter"
                fontSize="14px"
                fontWeight="400"
                lineHeight="20px"
                color="text.primary"
                sx={{ width: "55%" }}
              >
                Caterpillar 988f wheel loaders/integrated tools carriers 70
                Characters
              </Typography>
            </Box>
          </>
        )}
        <Heading text="Social Media" />
        <Box
          sx={{
            display: "flex",
            columnGap: "48px",
            alignItems: "center",
            marginTop: "-8px",
          }}
        >
          <Media image={Facebook} text="Facebook" />
          <Media image={Twitter} text="Twitter" />
        </Box>
        <Heading text="Messaging" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",

            marginTop: "-8px",
          }}
        >
          <Box
            sx={{ display: "flex", columnGap: "48px", marginBottom: "24px" }}
          >
            <Media image={Whatsapp} text="Whatsapp" />
            <Media image={Sms} text="SMS" />
          </Box>
          <Media image={Messanger} text="Messanger" />
        </Box>
        <Heading text="Copy Link" />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "94%",
            border: "1px solid #CFCFCF",
            borderRadius: "3px",
            height: "46.29px",
            marginTop: "-16px",
            paddingLeft: "13px",
            paddingRight: "5px",
          }}
        >
          <Typography
            variant="body2"
            fontFamily="Inter"
            fontSize="14px"
            fontWeight="400"
            lineHeight="20px"
            color="#616161"
          >
            https://www.machineryplanet.com/
          </Typography>
          <Button
            variant="outlined"
            sx={{
              width: "67px",
              height: "36px",
              textTransform: "capitalize",
              borderColor: "black",
              padding: "8px 16px",
              "&:hover": {
                borderColor: "black",
                backgroundColor: "text.primary",
              },
            }}
          >
            <Typography
              variant="body2"
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              lineHeight="20px"
              color="black"
              sx={{
                "&:hover": {
                  color: "white",
                },
              }}
            >
              Copy
            </Typography>
          </Button>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}

function Heading({ text }) {
  return (
    <Typography
      variant="subtitle1"
      fontFamily="Inter"
      fontSize="16px"
      fontWeight="600"
      lineHeight="24px"
      color="black"
    >
      {text}
    </Typography>
  );
}

function Media({ image, text }) {
  return (
    <Box sx={{ display: "flex", columnGap: "16px" }}>
      <img
        src={image}
        style={{ width: "24px", height: "24px", objectFit: "cover" }}
      />
      <Typography
        variant="body1"
        fontFamily="Inter"
        fontSize="16px"
        fontWeight="400"
        lineHeight="24px"
        color="black"
      >
        {text}
      </Typography>
    </Box>
  );
}
